export enum UploaderType {
  IMAGE,
  FILE,
}
